import { PROFESSIONAL_URL } from '@modules/business-manager/config/constants';

/**
 * The path every professional tab link hangs off, for whichever route tree is
 * actually mounted.
 *
 * The same tabs render on the public site and inside the Business Manager
 * preview, which serves them under `/professional-preview/`. Hardcoding the
 * public prefix means the preview's links point out of the preview, and — worse
 * — the active-tab comparison never matches its own location, so every tab
 * renders inactive and the preview looks like it never moved.
 */
export const professionalTabBase = (
    urlSegment: string,
    pathname: string,
): string => {
    const previewBase = `${PROFESSIONAL_URL.EDIT_MODE}/${urlSegment}`;
    return pathname.startsWith(`${PROFESSIONAL_URL.EDIT_MODE}/`)
        ? previewBase
        : `${PROFESSIONAL_URL.PUBLIC}/${urlSegment}`;
};

/**
 * Server-side counterpart for loaders that redirect between tabs. A tab route
 * shared by the public site and the preview must send the reader back to its
 * own tree — a hardcoded public path would throw the Business Manager preview
 * iframe out onto the live site.
 */
export const professionalTabBaseForRequest = (
    urlSegment: string,
    request: Request,
): string => professionalTabBase(urlSegment, new URL(request.url).pathname);
